import { render } from "./DocumentUpload.vue?vue&type=template&id=8e4d4130&scoped=true"
import script from "./DocumentUpload.vue?vue&type=script&lang=js"
export * from "./DocumentUpload.vue?vue&type=script&lang=js"

import "./DocumentUpload.vue?vue&type=style&index=0&id=8e4d4130&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e4d4130"]])

export default __exports__